import React, { useState, useEffect } from 'react';

const ContenedorLabor = (p) => {
    const data = p.data;
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const changeValue = (event) => {
        let { name, value } = event.target;
        let dt = { ...data };
        dt[name] = +value;
        p.changeChild({ index: p.index, value: dt });
    }
    const changedistribucion = (event) => {
        let { value } = event.target;
        let dt = { ...data };
        dt.distribucion = +value;
        if (dt.distribucion > 100) dt.distribucion = 100;
        if (dt.distribucion <= 0) dt.distribucion = 16.7;
        ajustar_distribucion(dt);
    }

    const changeMetaSemana = (event) => {
        let { value } = event.target;
        let dt = { ...data };
        dt[dias[0]] = +value;
        for (let i = 1; i < 6; i++) dt[dias[i]] = 0;
        ajustar_distribucion(dt);
    }

    const ajustar_distribucion = (dt) => {
        let total = 0;
        for (let i = 0; i < 6; i++) total += dt[dias[i]];
        let portion = Math.ceil(total / 100 * dt.distribucion);
        console.log(`total: ${total} portion: ${portion}`);
        for (let i = 0; i < 6; i++) {
            if (total === 0) dt[dias[i]] = 0;
            else if (total < portion) {
                dt[dias[i]] = total;
                total = 0;
            } else {
                dt[dias[i]] = portion;
                total -= portion;
            }
        }
        if (total > 0) dt[dias[0]] += total;
        p.changeChild({ index: p.index, value: dt });
    }

    const total_registraado = (dt) => {
        return dt.lunes + dt.martes + dt.miercoles + dt.jueves + dt.viernes + dt.sabado;
    }

    return (
        <div className={'bw-1400 p-2 round-s mr-0 ml-0 mt-2 mb-4 shadow bg-white ' + (p.seleccionado ? "border border-info scale-continue-0025 border-3" : "border-grey1") +
            (data.registrada === 1 ? " opacity-50" : "")}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-400 text-bold text-l contenedor border-bottom mt-1'>
                    {data.labor}
                    <span className='text-center text-400 text-s ms-2'>{data.area}</span>
                </div>
                <div className='bw-300 contenedor border-bottom mt-1'>
                    <span className='text-bold m-0 me-2 text-s'>Objetivos</span>
                    <div className='text-center text-bold text-xs'>
                        {data.area.toLowerCase() === "vivero" ? "Charolas" : "Tallos"}:
                        <span className='text-bold m-0 ms-1 me-3 text-s text-400'>{data.area.toLowerCase() === "vivero" ? data.meta_charolas : data.meta_tallos}</span>
                        Plantas:<span className='text-bold m-0 ms-1 me-0 text-s text-400'>{data.meta_plantas}</span>
                    </div>
                </div>
                <div className='bw-250 text-s contenedor border-bottom mt-1 text-bold text-red3'>{data.bloque}</div>
                <div className='bw-300 text-s contenedor border-bottom mt-1'>{data.unidad_hora} {data.unidad} X HORA</div>

                <div className='bw-250 contenedor border-bottom mt-1'>
                    <div className='text-center text-bold text-xs text-red3'>
                        Rancho<span className='text-bold m-0 me-3 ms-1 text-xs text-dark'>{data.rancho ?? 'N/A'}</span>
                        Valvula:<span className='text-bold m-0 ms-1 me-0 text-s text-400 text-dark'>{data.valvula ?? "N/A"}</span>
                    </div>
                </div>
                <div className='bw-400 contenedor border-bottom border-bottom mt-1'>
                    <div className='text-center text-bold text-xs text-red3'>
                        Semana siembra<span className='m-0 me-3 ms-1 text-s text-400 text-dark'>{data.semana_siembra}</span>
                        Semana trasplante:<span className='m-0 ms-1 me-3 text-s text-400 text-dark'>{data.semana_trasplante}</span>
                        Semana cosecha:<span className='m-0 ms-1 me-0 text-s text-400 text-dark'>{data.semana_cosecha}</span>
                    </div>
                </div>
                <div className='w-100 m-0 p-0 mt-2'></div>

                <div className='bw-100 mt-1'>
                    <div className='w-100 text-start text-bold text-xs'>Meta semanal</div>
                    <input type='number' min={0} step={0.1}
                        className='form-control form-control-sm w-100 shadow border-warning border-2'
                        name={'meta_semana'}
                        defaultValue={data.lunes + data.martes + data.miercoles + data.jueves + data.viernes + data.sabado}
                        disabled={data.registrada === 1}
                        onChange={changeMetaSemana} />
                </div>

                <div className='bw mt-1' style={{ width: "85px" }} >
                    <div className='w-100 text-start text-bold text-xs'>Distribución</div>
                    <input type='number' min={0} max={100} step={0.1}
                        className='form-control form-control-sm w-100 shadow border border-warning border-2'
                        name={'distribucion'}
                        value={data.distribucion}
                        disabled={data.registrada === 1}
                        onChange={changedistribucion} />
                </div>

                {
                    dias.map((d) => {
                        return (
                            <div className='bw mt-1' key={data.id + " dia" + d} style={{ width: "85px" }}>
                                <div className='w-100 text-start text-bold text-xs'>{d.toUpperCase()}</div>
                                <input type='number' min={0}
                                    disabled={data.registrada === 1}
                                    className='form-control form-control-sm w-100 shadow  border-grey3' name={d} value={data[d]} onChange={changeValue} />
                            </div>
                        )
                    })
                }
                {data.area.toLowerCase() !== "vivero" && <>
                    <div className='bw mt-1' style={{ width: "85px" }}>
                        <div className='w-100 text-start text-bold text-xs'>Valvula</div>
                        <input type='number' min={0}
                            className='form-control form-control-sm w-100 shadow  border-grey3 border-2'
                            name='valvula' value={data.valvula} onChange={changeValue} />
                    </div>
                    <div className='bw mt-1' style={{ width: "85px" }}>
                        <div className='w-100 text-start text-bold text-xs'>Tunel</div>
                        <input type='number' min={0}
                            className='form-control form-control-sm w-100 shadow  border-grey3 border-2'
                            name='tunel' value={data.tunel} onChange={changeValue} />
                    </div>
                    <div className='bw mt-1' style={{ width: "85px" }}>
                        <div className='w-100 text-start text-bold text-xs'>Cama inicio</div>
                        <input type='number' min={0}
                            className='form-control form-control-sm w-100 shadow border-2 border-info'
                            name='cama_inicio' value={data.cama_inicio} onChange={changeValue} />
                    </div>
                    <div className='bw mt-1' style={{ width: "85px" }}>
                        <div className='w-100 text-start text-bold text-xs'>Cama fin</div>
                        <input type='number' min={0}
                            className='form-control form-control-sm w-100 shadow border-2 border-info'
                            name='cama_fin' value={data.cama_fin} onChange={changeValue} />
                    </div>
                </>}



                <div className='w-100 m-0 p-0'></div>
                <button className={'btn btn-sm border round-xxl mt-2 mb-1 bw-400 text-bold scale-025 ' + (p.seleccionado ? " shadow btn-light shadow border-dark" : "btn-warning border")}
                    disabled={data.registrada === 1 || total_registraado(data) === 0}
                    onClick={() => { p.seleccionar(p.index) }}>{total_registraado(data) === 0 ? 'Agregue cantidades al menos a un día' : p.seleccionado ? 'Des-seleccionar' : 'Seleccionar'}</button>
            </div>
        </div>
    )
}

export default ContenedorLabor;